/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ChatDeleteChatParams,
  ChatDeletePostParams,
  ChatDto,
  ChatDtoPagination,
  ChatGetAllChatsParams,
  ChatGetChatByIdParams,
  ChatGetChatPostsParams,
  ChatGetChatsParams,
  ChatGetDirectChatIdParams,
  ChatGetFeedPostParams,
  ChatGetFeedPostsForUserParams,
  ChatGetFeedPostsParams,
  ChatGetLastReadPostIdParams,
  ChatJoinPublicGroupParams,
  ChatPostDto,
  ChatPostDtoPagination,
  ChatSoftDeleteChatMessageParams,
  ChatToggleInactivateChatParams,
  ChatToggleMuteChatParams,
  ChatToggleReactionParams,
  CreateChat,
  CreateChatPost,
  GetDirectChatIdResponse,
  ToggleSubscribeFeedRequest,
  UpdateChat,
  UpdateChatPostParam,
  UpdateReadMessageRequest
} from '../../model';

import { customInstance } from '../../../mutator';
import type { ErrorType , BodyType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getChatGetChatsUrl = (params?: ChatGetChatsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["chatTypeFilters"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Chat/GetChats?${stringifiedParams}` : `/api/Chat/GetChats`
}

export const chatGetChats = async (params?: ChatGetChatsParams, options?: RequestInit): Promise<ChatDtoPagination> => {
  
  return customInstance<ChatDtoPagination>(getChatGetChatsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getChatGetChatsQueryKey = (params?: ChatGetChatsParams,) => {
    return [
    `/api/Chat/GetChats`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getChatGetChatsQueryOptions = <TData = Awaited<ReturnType<typeof chatGetChats>>, TError = ErrorType<unknown>>(params?: ChatGetChatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatGetChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getChatGetChatsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof chatGetChats>>> = ({ signal }) => chatGetChats(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof chatGetChats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ChatGetChatsQueryResult = NonNullable<Awaited<ReturnType<typeof chatGetChats>>>
export type ChatGetChatsQueryError = ErrorType<unknown>


export function useChatGetChats<TData = Awaited<ReturnType<typeof chatGetChats>>, TError = ErrorType<unknown>>(
 params: undefined |  ChatGetChatsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatGetChats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof chatGetChats>>,
          TError,
          Awaited<ReturnType<typeof chatGetChats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChatGetChats<TData = Awaited<ReturnType<typeof chatGetChats>>, TError = ErrorType<unknown>>(
 params?: ChatGetChatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatGetChats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof chatGetChats>>,
          TError,
          Awaited<ReturnType<typeof chatGetChats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChatGetChats<TData = Awaited<ReturnType<typeof chatGetChats>>, TError = ErrorType<unknown>>(
 params?: ChatGetChatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatGetChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useChatGetChats<TData = Awaited<ReturnType<typeof chatGetChats>>, TError = ErrorType<unknown>>(
 params?: ChatGetChatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatGetChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getChatGetChatsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getChatGetChatsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof chatGetChats>>, TError = ErrorType<unknown>>(params?: ChatGetChatsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getChatGetChatsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof chatGetChats>>> = ({ signal }) => chatGetChats(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetChats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ChatGetChatsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof chatGetChats>>>
export type ChatGetChatsSuspenseQueryError = ErrorType<unknown>


export function useChatGetChatsSuspense<TData = Awaited<ReturnType<typeof chatGetChats>>, TError = ErrorType<unknown>>(
 params: undefined |  ChatGetChatsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChatGetChatsSuspense<TData = Awaited<ReturnType<typeof chatGetChats>>, TError = ErrorType<unknown>>(
 params?: ChatGetChatsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChatGetChatsSuspense<TData = Awaited<ReturnType<typeof chatGetChats>>, TError = ErrorType<unknown>>(
 params?: ChatGetChatsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useChatGetChatsSuspense<TData = Awaited<ReturnType<typeof chatGetChats>>, TError = ErrorType<unknown>>(
 params?: ChatGetChatsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getChatGetChatsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getChatCreateChatUrl = () => {


  

  return `/api/Chat/CreateChat`
}

export const chatCreateChat = async (createChat: CreateChat, options?: RequestInit): Promise<ChatDto> => {
  
  return customInstance<ChatDto>(getChatCreateChatUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createChat,)
  }
);}




export const getChatCreateChatMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chatCreateChat>>, TError,{data: BodyType<CreateChat>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof chatCreateChat>>, TError,{data: BodyType<CreateChat>}, TContext> => {

const mutationKey = ['chatCreateChat'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof chatCreateChat>>, {data: BodyType<CreateChat>}> = (props) => {
          const {data} = props ?? {};

          return  chatCreateChat(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ChatCreateChatMutationResult = NonNullable<Awaited<ReturnType<typeof chatCreateChat>>>
    export type ChatCreateChatMutationBody = BodyType<CreateChat>
    export type ChatCreateChatMutationError = ErrorType<unknown>

    export const useChatCreateChat = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chatCreateChat>>, TError,{data: BodyType<CreateChat>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof chatCreateChat>>,
        TError,
        {data: BodyType<CreateChat>},
        TContext
      > => {

      const mutationOptions = getChatCreateChatMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getChatGetChatByIdUrl = (params: ChatGetChatByIdParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Chat/GetChatById?${stringifiedParams}` : `/api/Chat/GetChatById`
}

export const chatGetChatById = async (params: ChatGetChatByIdParams, options?: RequestInit): Promise<ChatDto> => {
  
  return customInstance<ChatDto>(getChatGetChatByIdUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getChatGetChatByIdQueryKey = (params?: ChatGetChatByIdParams,) => {
    return [
    `/api/Chat/GetChatById`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getChatGetChatByIdQueryOptions = <TData = Awaited<ReturnType<typeof chatGetChatById>>, TError = ErrorType<unknown>>(params: ChatGetChatByIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatGetChatById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getChatGetChatByIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof chatGetChatById>>> = ({ signal }) => chatGetChatById(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof chatGetChatById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ChatGetChatByIdQueryResult = NonNullable<Awaited<ReturnType<typeof chatGetChatById>>>
export type ChatGetChatByIdQueryError = ErrorType<unknown>


export function useChatGetChatById<TData = Awaited<ReturnType<typeof chatGetChatById>>, TError = ErrorType<unknown>>(
 params: ChatGetChatByIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatGetChatById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof chatGetChatById>>,
          TError,
          Awaited<ReturnType<typeof chatGetChatById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChatGetChatById<TData = Awaited<ReturnType<typeof chatGetChatById>>, TError = ErrorType<unknown>>(
 params: ChatGetChatByIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatGetChatById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof chatGetChatById>>,
          TError,
          Awaited<ReturnType<typeof chatGetChatById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChatGetChatById<TData = Awaited<ReturnType<typeof chatGetChatById>>, TError = ErrorType<unknown>>(
 params: ChatGetChatByIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatGetChatById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useChatGetChatById<TData = Awaited<ReturnType<typeof chatGetChatById>>, TError = ErrorType<unknown>>(
 params: ChatGetChatByIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatGetChatById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getChatGetChatByIdQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getChatGetChatByIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof chatGetChatById>>, TError = ErrorType<unknown>>(params: ChatGetChatByIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetChatById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getChatGetChatByIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof chatGetChatById>>> = ({ signal }) => chatGetChatById(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetChatById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ChatGetChatByIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof chatGetChatById>>>
export type ChatGetChatByIdSuspenseQueryError = ErrorType<unknown>


export function useChatGetChatByIdSuspense<TData = Awaited<ReturnType<typeof chatGetChatById>>, TError = ErrorType<unknown>>(
 params: ChatGetChatByIdParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetChatById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChatGetChatByIdSuspense<TData = Awaited<ReturnType<typeof chatGetChatById>>, TError = ErrorType<unknown>>(
 params: ChatGetChatByIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetChatById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChatGetChatByIdSuspense<TData = Awaited<ReturnType<typeof chatGetChatById>>, TError = ErrorType<unknown>>(
 params: ChatGetChatByIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetChatById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useChatGetChatByIdSuspense<TData = Awaited<ReturnType<typeof chatGetChatById>>, TError = ErrorType<unknown>>(
 params: ChatGetChatByIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetChatById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getChatGetChatByIdSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getChatCreateChatPostUrl = () => {


  

  return `/api/Chat/CreateChatPost`
}

export const chatCreateChatPost = async (createChatPost: CreateChatPost, options?: RequestInit): Promise<number> => {
  
  return customInstance<number>(getChatCreateChatPostUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createChatPost,)
  }
);}




export const getChatCreateChatPostMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chatCreateChatPost>>, TError,{data: BodyType<CreateChatPost>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof chatCreateChatPost>>, TError,{data: BodyType<CreateChatPost>}, TContext> => {

const mutationKey = ['chatCreateChatPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof chatCreateChatPost>>, {data: BodyType<CreateChatPost>}> = (props) => {
          const {data} = props ?? {};

          return  chatCreateChatPost(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ChatCreateChatPostMutationResult = NonNullable<Awaited<ReturnType<typeof chatCreateChatPost>>>
    export type ChatCreateChatPostMutationBody = BodyType<CreateChatPost>
    export type ChatCreateChatPostMutationError = ErrorType<unknown>

    export const useChatCreateChatPost = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chatCreateChatPost>>, TError,{data: BodyType<CreateChatPost>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof chatCreateChatPost>>,
        TError,
        {data: BodyType<CreateChatPost>},
        TContext
      > => {

      const mutationOptions = getChatCreateChatPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getChatUpdateMessageContentUrl = () => {


  

  return `/api/Chat/UpdateMessageContent`
}

export const chatUpdateMessageContent = async (updateChatPostParam: UpdateChatPostParam, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getChatUpdateMessageContentUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateChatPostParam,)
  }
);}




export const getChatUpdateMessageContentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chatUpdateMessageContent>>, TError,{data: BodyType<UpdateChatPostParam>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof chatUpdateMessageContent>>, TError,{data: BodyType<UpdateChatPostParam>}, TContext> => {

const mutationKey = ['chatUpdateMessageContent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof chatUpdateMessageContent>>, {data: BodyType<UpdateChatPostParam>}> = (props) => {
          const {data} = props ?? {};

          return  chatUpdateMessageContent(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ChatUpdateMessageContentMutationResult = NonNullable<Awaited<ReturnType<typeof chatUpdateMessageContent>>>
    export type ChatUpdateMessageContentMutationBody = BodyType<UpdateChatPostParam>
    export type ChatUpdateMessageContentMutationError = ErrorType<unknown>

    export const useChatUpdateMessageContent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chatUpdateMessageContent>>, TError,{data: BodyType<UpdateChatPostParam>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof chatUpdateMessageContent>>,
        TError,
        {data: BodyType<UpdateChatPostParam>},
        TContext
      > => {

      const mutationOptions = getChatUpdateMessageContentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getChatUpdateChatUrl = () => {


  

  return `/api/Chat/UpdateChat`
}

export const chatUpdateChat = async (updateChat: UpdateChat, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getChatUpdateChatUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateChat,)
  }
);}




export const getChatUpdateChatMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chatUpdateChat>>, TError,{data: BodyType<UpdateChat>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof chatUpdateChat>>, TError,{data: BodyType<UpdateChat>}, TContext> => {

const mutationKey = ['chatUpdateChat'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof chatUpdateChat>>, {data: BodyType<UpdateChat>}> = (props) => {
          const {data} = props ?? {};

          return  chatUpdateChat(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ChatUpdateChatMutationResult = NonNullable<Awaited<ReturnType<typeof chatUpdateChat>>>
    export type ChatUpdateChatMutationBody = BodyType<UpdateChat>
    export type ChatUpdateChatMutationError = ErrorType<unknown>

    export const useChatUpdateChat = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chatUpdateChat>>, TError,{data: BodyType<UpdateChat>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof chatUpdateChat>>,
        TError,
        {data: BodyType<UpdateChat>},
        TContext
      > => {

      const mutationOptions = getChatUpdateChatMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getChatGetAllChatsUrl = (params?: ChatGetAllChatsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["chatTypeFilters"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Chat/GetAllChats?${stringifiedParams}` : `/api/Chat/GetAllChats`
}

export const chatGetAllChats = async (params?: ChatGetAllChatsParams, options?: RequestInit): Promise<ChatDtoPagination> => {
  
  return customInstance<ChatDtoPagination>(getChatGetAllChatsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getChatGetAllChatsQueryKey = (params?: ChatGetAllChatsParams,) => {
    return [
    `/api/Chat/GetAllChats`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getChatGetAllChatsQueryOptions = <TData = Awaited<ReturnType<typeof chatGetAllChats>>, TError = ErrorType<unknown>>(params?: ChatGetAllChatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatGetAllChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getChatGetAllChatsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof chatGetAllChats>>> = ({ signal }) => chatGetAllChats(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof chatGetAllChats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ChatGetAllChatsQueryResult = NonNullable<Awaited<ReturnType<typeof chatGetAllChats>>>
export type ChatGetAllChatsQueryError = ErrorType<unknown>


export function useChatGetAllChats<TData = Awaited<ReturnType<typeof chatGetAllChats>>, TError = ErrorType<unknown>>(
 params: undefined |  ChatGetAllChatsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatGetAllChats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof chatGetAllChats>>,
          TError,
          Awaited<ReturnType<typeof chatGetAllChats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChatGetAllChats<TData = Awaited<ReturnType<typeof chatGetAllChats>>, TError = ErrorType<unknown>>(
 params?: ChatGetAllChatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatGetAllChats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof chatGetAllChats>>,
          TError,
          Awaited<ReturnType<typeof chatGetAllChats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChatGetAllChats<TData = Awaited<ReturnType<typeof chatGetAllChats>>, TError = ErrorType<unknown>>(
 params?: ChatGetAllChatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatGetAllChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useChatGetAllChats<TData = Awaited<ReturnType<typeof chatGetAllChats>>, TError = ErrorType<unknown>>(
 params?: ChatGetAllChatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatGetAllChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getChatGetAllChatsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getChatGetAllChatsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof chatGetAllChats>>, TError = ErrorType<unknown>>(params?: ChatGetAllChatsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetAllChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getChatGetAllChatsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof chatGetAllChats>>> = ({ signal }) => chatGetAllChats(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetAllChats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ChatGetAllChatsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof chatGetAllChats>>>
export type ChatGetAllChatsSuspenseQueryError = ErrorType<unknown>


export function useChatGetAllChatsSuspense<TData = Awaited<ReturnType<typeof chatGetAllChats>>, TError = ErrorType<unknown>>(
 params: undefined |  ChatGetAllChatsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetAllChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChatGetAllChatsSuspense<TData = Awaited<ReturnType<typeof chatGetAllChats>>, TError = ErrorType<unknown>>(
 params?: ChatGetAllChatsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetAllChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChatGetAllChatsSuspense<TData = Awaited<ReturnType<typeof chatGetAllChats>>, TError = ErrorType<unknown>>(
 params?: ChatGetAllChatsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetAllChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useChatGetAllChatsSuspense<TData = Awaited<ReturnType<typeof chatGetAllChats>>, TError = ErrorType<unknown>>(
 params?: ChatGetAllChatsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetAllChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getChatGetAllChatsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getChatDeleteChatUrl = (params?: ChatDeleteChatParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Chat/DeleteChat?${stringifiedParams}` : `/api/Chat/DeleteChat`
}

export const chatDeleteChat = async (params?: ChatDeleteChatParams, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getChatDeleteChatUrl(params),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getChatDeleteChatMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chatDeleteChat>>, TError,{params?: ChatDeleteChatParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof chatDeleteChat>>, TError,{params?: ChatDeleteChatParams}, TContext> => {

const mutationKey = ['chatDeleteChat'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof chatDeleteChat>>, {params?: ChatDeleteChatParams}> = (props) => {
          const {params} = props ?? {};

          return  chatDeleteChat(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ChatDeleteChatMutationResult = NonNullable<Awaited<ReturnType<typeof chatDeleteChat>>>
    
    export type ChatDeleteChatMutationError = ErrorType<unknown>

    export const useChatDeleteChat = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chatDeleteChat>>, TError,{params?: ChatDeleteChatParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof chatDeleteChat>>,
        TError,
        {params?: ChatDeleteChatParams},
        TContext
      > => {

      const mutationOptions = getChatDeleteChatMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getChatGetUnreadCountUrl = () => {


  

  return `/api/Chat/GetUnreadCount`
}

export const chatGetUnreadCount = async ( options?: RequestInit): Promise<number> => {
  
  return customInstance<number>(getChatGetUnreadCountUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getChatGetUnreadCountQueryKey = () => {
    return [
    `/api/Chat/GetUnreadCount`
    ] as const;
    }

    
export const getChatGetUnreadCountQueryOptions = <TData = Awaited<ReturnType<typeof chatGetUnreadCount>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatGetUnreadCount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getChatGetUnreadCountQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof chatGetUnreadCount>>> = ({ signal }) => chatGetUnreadCount({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof chatGetUnreadCount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ChatGetUnreadCountQueryResult = NonNullable<Awaited<ReturnType<typeof chatGetUnreadCount>>>
export type ChatGetUnreadCountQueryError = ErrorType<unknown>


export function useChatGetUnreadCount<TData = Awaited<ReturnType<typeof chatGetUnreadCount>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatGetUnreadCount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof chatGetUnreadCount>>,
          TError,
          Awaited<ReturnType<typeof chatGetUnreadCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChatGetUnreadCount<TData = Awaited<ReturnType<typeof chatGetUnreadCount>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatGetUnreadCount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof chatGetUnreadCount>>,
          TError,
          Awaited<ReturnType<typeof chatGetUnreadCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChatGetUnreadCount<TData = Awaited<ReturnType<typeof chatGetUnreadCount>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatGetUnreadCount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useChatGetUnreadCount<TData = Awaited<ReturnType<typeof chatGetUnreadCount>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatGetUnreadCount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getChatGetUnreadCountQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getChatGetUnreadCountSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof chatGetUnreadCount>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetUnreadCount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getChatGetUnreadCountQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof chatGetUnreadCount>>> = ({ signal }) => chatGetUnreadCount({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetUnreadCount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ChatGetUnreadCountSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof chatGetUnreadCount>>>
export type ChatGetUnreadCountSuspenseQueryError = ErrorType<unknown>


export function useChatGetUnreadCountSuspense<TData = Awaited<ReturnType<typeof chatGetUnreadCount>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetUnreadCount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChatGetUnreadCountSuspense<TData = Awaited<ReturnType<typeof chatGetUnreadCount>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetUnreadCount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChatGetUnreadCountSuspense<TData = Awaited<ReturnType<typeof chatGetUnreadCount>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetUnreadCount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useChatGetUnreadCountSuspense<TData = Awaited<ReturnType<typeof chatGetUnreadCount>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetUnreadCount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getChatGetUnreadCountSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getChatGetChatPostsUrl = (params?: ChatGetChatPostsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Chat/GetChatPosts?${stringifiedParams}` : `/api/Chat/GetChatPosts`
}

export const chatGetChatPosts = async (params?: ChatGetChatPostsParams, options?: RequestInit): Promise<ChatPostDtoPagination> => {
  
  return customInstance<ChatPostDtoPagination>(getChatGetChatPostsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getChatGetChatPostsQueryKey = (params?: ChatGetChatPostsParams,) => {
    return [
    `/api/Chat/GetChatPosts`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getChatGetChatPostsQueryOptions = <TData = Awaited<ReturnType<typeof chatGetChatPosts>>, TError = ErrorType<unknown>>(params?: ChatGetChatPostsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatGetChatPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getChatGetChatPostsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof chatGetChatPosts>>> = ({ signal }) => chatGetChatPosts(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof chatGetChatPosts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ChatGetChatPostsQueryResult = NonNullable<Awaited<ReturnType<typeof chatGetChatPosts>>>
export type ChatGetChatPostsQueryError = ErrorType<unknown>


export function useChatGetChatPosts<TData = Awaited<ReturnType<typeof chatGetChatPosts>>, TError = ErrorType<unknown>>(
 params: undefined |  ChatGetChatPostsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatGetChatPosts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof chatGetChatPosts>>,
          TError,
          Awaited<ReturnType<typeof chatGetChatPosts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChatGetChatPosts<TData = Awaited<ReturnType<typeof chatGetChatPosts>>, TError = ErrorType<unknown>>(
 params?: ChatGetChatPostsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatGetChatPosts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof chatGetChatPosts>>,
          TError,
          Awaited<ReturnType<typeof chatGetChatPosts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChatGetChatPosts<TData = Awaited<ReturnType<typeof chatGetChatPosts>>, TError = ErrorType<unknown>>(
 params?: ChatGetChatPostsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatGetChatPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useChatGetChatPosts<TData = Awaited<ReturnType<typeof chatGetChatPosts>>, TError = ErrorType<unknown>>(
 params?: ChatGetChatPostsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatGetChatPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getChatGetChatPostsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getChatGetChatPostsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof chatGetChatPosts>>, TError = ErrorType<unknown>>(params?: ChatGetChatPostsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetChatPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getChatGetChatPostsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof chatGetChatPosts>>> = ({ signal }) => chatGetChatPosts(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetChatPosts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ChatGetChatPostsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof chatGetChatPosts>>>
export type ChatGetChatPostsSuspenseQueryError = ErrorType<unknown>


export function useChatGetChatPostsSuspense<TData = Awaited<ReturnType<typeof chatGetChatPosts>>, TError = ErrorType<unknown>>(
 params: undefined |  ChatGetChatPostsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetChatPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChatGetChatPostsSuspense<TData = Awaited<ReturnType<typeof chatGetChatPosts>>, TError = ErrorType<unknown>>(
 params?: ChatGetChatPostsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetChatPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChatGetChatPostsSuspense<TData = Awaited<ReturnType<typeof chatGetChatPosts>>, TError = ErrorType<unknown>>(
 params?: ChatGetChatPostsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetChatPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useChatGetChatPostsSuspense<TData = Awaited<ReturnType<typeof chatGetChatPosts>>, TError = ErrorType<unknown>>(
 params?: ChatGetChatPostsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetChatPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getChatGetChatPostsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getChatUpdateReadMessageUrl = () => {


  

  return `/api/Chat/UpdateReadMessage`
}

export const chatUpdateReadMessage = async (updateReadMessageRequest: UpdateReadMessageRequest, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getChatUpdateReadMessageUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateReadMessageRequest,)
  }
);}




export const getChatUpdateReadMessageMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chatUpdateReadMessage>>, TError,{data: BodyType<UpdateReadMessageRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof chatUpdateReadMessage>>, TError,{data: BodyType<UpdateReadMessageRequest>}, TContext> => {

const mutationKey = ['chatUpdateReadMessage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof chatUpdateReadMessage>>, {data: BodyType<UpdateReadMessageRequest>}> = (props) => {
          const {data} = props ?? {};

          return  chatUpdateReadMessage(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ChatUpdateReadMessageMutationResult = NonNullable<Awaited<ReturnType<typeof chatUpdateReadMessage>>>
    export type ChatUpdateReadMessageMutationBody = BodyType<UpdateReadMessageRequest>
    export type ChatUpdateReadMessageMutationError = ErrorType<unknown>

    export const useChatUpdateReadMessage = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chatUpdateReadMessage>>, TError,{data: BodyType<UpdateReadMessageRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof chatUpdateReadMessage>>,
        TError,
        {data: BodyType<UpdateReadMessageRequest>},
        TContext
      > => {

      const mutationOptions = getChatUpdateReadMessageMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getChatJoinPublicGroupUrl = (params: ChatJoinPublicGroupParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Chat/JoinPublicGroup?${stringifiedParams}` : `/api/Chat/JoinPublicGroup`
}

export const chatJoinPublicGroup = async (params: ChatJoinPublicGroupParams, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getChatJoinPublicGroupUrl(params),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getChatJoinPublicGroupMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chatJoinPublicGroup>>, TError,{params: ChatJoinPublicGroupParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof chatJoinPublicGroup>>, TError,{params: ChatJoinPublicGroupParams}, TContext> => {

const mutationKey = ['chatJoinPublicGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof chatJoinPublicGroup>>, {params: ChatJoinPublicGroupParams}> = (props) => {
          const {params} = props ?? {};

          return  chatJoinPublicGroup(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ChatJoinPublicGroupMutationResult = NonNullable<Awaited<ReturnType<typeof chatJoinPublicGroup>>>
    
    export type ChatJoinPublicGroupMutationError = ErrorType<unknown>

    export const useChatJoinPublicGroup = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chatJoinPublicGroup>>, TError,{params: ChatJoinPublicGroupParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof chatJoinPublicGroup>>,
        TError,
        {params: ChatJoinPublicGroupParams},
        TContext
      > => {

      const mutationOptions = getChatJoinPublicGroupMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getChatToggleMuteChatUrl = (params: ChatToggleMuteChatParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Chat/ToggleMuteChat?${stringifiedParams}` : `/api/Chat/ToggleMuteChat`
}

export const chatToggleMuteChat = async (params: ChatToggleMuteChatParams, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getChatToggleMuteChatUrl(params),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getChatToggleMuteChatMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chatToggleMuteChat>>, TError,{params: ChatToggleMuteChatParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof chatToggleMuteChat>>, TError,{params: ChatToggleMuteChatParams}, TContext> => {

const mutationKey = ['chatToggleMuteChat'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof chatToggleMuteChat>>, {params: ChatToggleMuteChatParams}> = (props) => {
          const {params} = props ?? {};

          return  chatToggleMuteChat(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ChatToggleMuteChatMutationResult = NonNullable<Awaited<ReturnType<typeof chatToggleMuteChat>>>
    
    export type ChatToggleMuteChatMutationError = ErrorType<unknown>

    export const useChatToggleMuteChat = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chatToggleMuteChat>>, TError,{params: ChatToggleMuteChatParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof chatToggleMuteChat>>,
        TError,
        {params: ChatToggleMuteChatParams},
        TContext
      > => {

      const mutationOptions = getChatToggleMuteChatMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getChatToggleInactivateChatUrl = (params: ChatToggleInactivateChatParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Chat/ToggleInactivateChat?${stringifiedParams}` : `/api/Chat/ToggleInactivateChat`
}

export const chatToggleInactivateChat = async (params: ChatToggleInactivateChatParams, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getChatToggleInactivateChatUrl(params),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getChatToggleInactivateChatMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chatToggleInactivateChat>>, TError,{params: ChatToggleInactivateChatParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof chatToggleInactivateChat>>, TError,{params: ChatToggleInactivateChatParams}, TContext> => {

const mutationKey = ['chatToggleInactivateChat'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof chatToggleInactivateChat>>, {params: ChatToggleInactivateChatParams}> = (props) => {
          const {params} = props ?? {};

          return  chatToggleInactivateChat(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ChatToggleInactivateChatMutationResult = NonNullable<Awaited<ReturnType<typeof chatToggleInactivateChat>>>
    
    export type ChatToggleInactivateChatMutationError = ErrorType<unknown>

    export const useChatToggleInactivateChat = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chatToggleInactivateChat>>, TError,{params: ChatToggleInactivateChatParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof chatToggleInactivateChat>>,
        TError,
        {params: ChatToggleInactivateChatParams},
        TContext
      > => {

      const mutationOptions = getChatToggleInactivateChatMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getChatUserHasArchivedChatUrl = () => {


  

  return `/api/Chat/UserHasArchivedChat`
}

export const chatUserHasArchivedChat = async ( options?: RequestInit): Promise<boolean> => {
  
  return customInstance<boolean>(getChatUserHasArchivedChatUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getChatUserHasArchivedChatQueryKey = () => {
    return [
    `/api/Chat/UserHasArchivedChat`
    ] as const;
    }

    
export const getChatUserHasArchivedChatQueryOptions = <TData = Awaited<ReturnType<typeof chatUserHasArchivedChat>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatUserHasArchivedChat>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getChatUserHasArchivedChatQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof chatUserHasArchivedChat>>> = ({ signal }) => chatUserHasArchivedChat({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof chatUserHasArchivedChat>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ChatUserHasArchivedChatQueryResult = NonNullable<Awaited<ReturnType<typeof chatUserHasArchivedChat>>>
export type ChatUserHasArchivedChatQueryError = ErrorType<unknown>


export function useChatUserHasArchivedChat<TData = Awaited<ReturnType<typeof chatUserHasArchivedChat>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatUserHasArchivedChat>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof chatUserHasArchivedChat>>,
          TError,
          Awaited<ReturnType<typeof chatUserHasArchivedChat>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChatUserHasArchivedChat<TData = Awaited<ReturnType<typeof chatUserHasArchivedChat>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatUserHasArchivedChat>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof chatUserHasArchivedChat>>,
          TError,
          Awaited<ReturnType<typeof chatUserHasArchivedChat>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChatUserHasArchivedChat<TData = Awaited<ReturnType<typeof chatUserHasArchivedChat>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatUserHasArchivedChat>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useChatUserHasArchivedChat<TData = Awaited<ReturnType<typeof chatUserHasArchivedChat>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatUserHasArchivedChat>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getChatUserHasArchivedChatQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getChatUserHasArchivedChatSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof chatUserHasArchivedChat>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatUserHasArchivedChat>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getChatUserHasArchivedChatQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof chatUserHasArchivedChat>>> = ({ signal }) => chatUserHasArchivedChat({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatUserHasArchivedChat>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ChatUserHasArchivedChatSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof chatUserHasArchivedChat>>>
export type ChatUserHasArchivedChatSuspenseQueryError = ErrorType<unknown>


export function useChatUserHasArchivedChatSuspense<TData = Awaited<ReturnType<typeof chatUserHasArchivedChat>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatUserHasArchivedChat>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChatUserHasArchivedChatSuspense<TData = Awaited<ReturnType<typeof chatUserHasArchivedChat>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatUserHasArchivedChat>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChatUserHasArchivedChatSuspense<TData = Awaited<ReturnType<typeof chatUserHasArchivedChat>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatUserHasArchivedChat>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useChatUserHasArchivedChatSuspense<TData = Awaited<ReturnType<typeof chatUserHasArchivedChat>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatUserHasArchivedChat>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getChatUserHasArchivedChatSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getChatGetLastReadPostIdUrl = (params?: ChatGetLastReadPostIdParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Chat/GetLastReadPostId?${stringifiedParams}` : `/api/Chat/GetLastReadPostId`
}

export const chatGetLastReadPostId = async (params?: ChatGetLastReadPostIdParams, options?: RequestInit): Promise<number> => {
  
  return customInstance<number>(getChatGetLastReadPostIdUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getChatGetLastReadPostIdQueryKey = (params?: ChatGetLastReadPostIdParams,) => {
    return [
    `/api/Chat/GetLastReadPostId`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getChatGetLastReadPostIdQueryOptions = <TData = Awaited<ReturnType<typeof chatGetLastReadPostId>>, TError = ErrorType<unknown>>(params?: ChatGetLastReadPostIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatGetLastReadPostId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getChatGetLastReadPostIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof chatGetLastReadPostId>>> = ({ signal }) => chatGetLastReadPostId(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof chatGetLastReadPostId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ChatGetLastReadPostIdQueryResult = NonNullable<Awaited<ReturnType<typeof chatGetLastReadPostId>>>
export type ChatGetLastReadPostIdQueryError = ErrorType<unknown>


export function useChatGetLastReadPostId<TData = Awaited<ReturnType<typeof chatGetLastReadPostId>>, TError = ErrorType<unknown>>(
 params: undefined |  ChatGetLastReadPostIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatGetLastReadPostId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof chatGetLastReadPostId>>,
          TError,
          Awaited<ReturnType<typeof chatGetLastReadPostId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChatGetLastReadPostId<TData = Awaited<ReturnType<typeof chatGetLastReadPostId>>, TError = ErrorType<unknown>>(
 params?: ChatGetLastReadPostIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatGetLastReadPostId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof chatGetLastReadPostId>>,
          TError,
          Awaited<ReturnType<typeof chatGetLastReadPostId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChatGetLastReadPostId<TData = Awaited<ReturnType<typeof chatGetLastReadPostId>>, TError = ErrorType<unknown>>(
 params?: ChatGetLastReadPostIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatGetLastReadPostId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useChatGetLastReadPostId<TData = Awaited<ReturnType<typeof chatGetLastReadPostId>>, TError = ErrorType<unknown>>(
 params?: ChatGetLastReadPostIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatGetLastReadPostId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getChatGetLastReadPostIdQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getChatGetLastReadPostIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof chatGetLastReadPostId>>, TError = ErrorType<unknown>>(params?: ChatGetLastReadPostIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetLastReadPostId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getChatGetLastReadPostIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof chatGetLastReadPostId>>> = ({ signal }) => chatGetLastReadPostId(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetLastReadPostId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ChatGetLastReadPostIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof chatGetLastReadPostId>>>
export type ChatGetLastReadPostIdSuspenseQueryError = ErrorType<unknown>


export function useChatGetLastReadPostIdSuspense<TData = Awaited<ReturnType<typeof chatGetLastReadPostId>>, TError = ErrorType<unknown>>(
 params: undefined |  ChatGetLastReadPostIdParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetLastReadPostId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChatGetLastReadPostIdSuspense<TData = Awaited<ReturnType<typeof chatGetLastReadPostId>>, TError = ErrorType<unknown>>(
 params?: ChatGetLastReadPostIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetLastReadPostId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChatGetLastReadPostIdSuspense<TData = Awaited<ReturnType<typeof chatGetLastReadPostId>>, TError = ErrorType<unknown>>(
 params?: ChatGetLastReadPostIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetLastReadPostId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useChatGetLastReadPostIdSuspense<TData = Awaited<ReturnType<typeof chatGetLastReadPostId>>, TError = ErrorType<unknown>>(
 params?: ChatGetLastReadPostIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetLastReadPostId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getChatGetLastReadPostIdSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getChatUserCanCreateChatsUrl = () => {


  

  return `/api/Chat/UserCanCreateChats`
}

export const chatUserCanCreateChats = async ( options?: RequestInit): Promise<boolean> => {
  
  return customInstance<boolean>(getChatUserCanCreateChatsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getChatUserCanCreateChatsQueryKey = () => {
    return [
    `/api/Chat/UserCanCreateChats`
    ] as const;
    }

    
export const getChatUserCanCreateChatsQueryOptions = <TData = Awaited<ReturnType<typeof chatUserCanCreateChats>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatUserCanCreateChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getChatUserCanCreateChatsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof chatUserCanCreateChats>>> = ({ signal }) => chatUserCanCreateChats({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof chatUserCanCreateChats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ChatUserCanCreateChatsQueryResult = NonNullable<Awaited<ReturnType<typeof chatUserCanCreateChats>>>
export type ChatUserCanCreateChatsQueryError = ErrorType<unknown>


export function useChatUserCanCreateChats<TData = Awaited<ReturnType<typeof chatUserCanCreateChats>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatUserCanCreateChats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof chatUserCanCreateChats>>,
          TError,
          Awaited<ReturnType<typeof chatUserCanCreateChats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChatUserCanCreateChats<TData = Awaited<ReturnType<typeof chatUserCanCreateChats>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatUserCanCreateChats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof chatUserCanCreateChats>>,
          TError,
          Awaited<ReturnType<typeof chatUserCanCreateChats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChatUserCanCreateChats<TData = Awaited<ReturnType<typeof chatUserCanCreateChats>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatUserCanCreateChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useChatUserCanCreateChats<TData = Awaited<ReturnType<typeof chatUserCanCreateChats>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatUserCanCreateChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getChatUserCanCreateChatsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getChatUserCanCreateChatsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof chatUserCanCreateChats>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatUserCanCreateChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getChatUserCanCreateChatsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof chatUserCanCreateChats>>> = ({ signal }) => chatUserCanCreateChats({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatUserCanCreateChats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ChatUserCanCreateChatsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof chatUserCanCreateChats>>>
export type ChatUserCanCreateChatsSuspenseQueryError = ErrorType<unknown>


export function useChatUserCanCreateChatsSuspense<TData = Awaited<ReturnType<typeof chatUserCanCreateChats>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatUserCanCreateChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChatUserCanCreateChatsSuspense<TData = Awaited<ReturnType<typeof chatUserCanCreateChats>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatUserCanCreateChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChatUserCanCreateChatsSuspense<TData = Awaited<ReturnType<typeof chatUserCanCreateChats>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatUserCanCreateChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useChatUserCanCreateChatsSuspense<TData = Awaited<ReturnType<typeof chatUserCanCreateChats>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatUserCanCreateChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getChatUserCanCreateChatsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getChatGetDirectChatIdUrl = (params?: ChatGetDirectChatIdParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Chat/GetDirectChatId?${stringifiedParams}` : `/api/Chat/GetDirectChatId`
}

export const chatGetDirectChatId = async (params?: ChatGetDirectChatIdParams, options?: RequestInit): Promise<GetDirectChatIdResponse> => {
  
  return customInstance<GetDirectChatIdResponse>(getChatGetDirectChatIdUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getChatGetDirectChatIdQueryKey = (params?: ChatGetDirectChatIdParams,) => {
    return [
    `/api/Chat/GetDirectChatId`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getChatGetDirectChatIdQueryOptions = <TData = Awaited<ReturnType<typeof chatGetDirectChatId>>, TError = ErrorType<unknown>>(params?: ChatGetDirectChatIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatGetDirectChatId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getChatGetDirectChatIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof chatGetDirectChatId>>> = ({ signal }) => chatGetDirectChatId(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof chatGetDirectChatId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ChatGetDirectChatIdQueryResult = NonNullable<Awaited<ReturnType<typeof chatGetDirectChatId>>>
export type ChatGetDirectChatIdQueryError = ErrorType<unknown>


export function useChatGetDirectChatId<TData = Awaited<ReturnType<typeof chatGetDirectChatId>>, TError = ErrorType<unknown>>(
 params: undefined |  ChatGetDirectChatIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatGetDirectChatId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof chatGetDirectChatId>>,
          TError,
          Awaited<ReturnType<typeof chatGetDirectChatId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChatGetDirectChatId<TData = Awaited<ReturnType<typeof chatGetDirectChatId>>, TError = ErrorType<unknown>>(
 params?: ChatGetDirectChatIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatGetDirectChatId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof chatGetDirectChatId>>,
          TError,
          Awaited<ReturnType<typeof chatGetDirectChatId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChatGetDirectChatId<TData = Awaited<ReturnType<typeof chatGetDirectChatId>>, TError = ErrorType<unknown>>(
 params?: ChatGetDirectChatIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatGetDirectChatId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useChatGetDirectChatId<TData = Awaited<ReturnType<typeof chatGetDirectChatId>>, TError = ErrorType<unknown>>(
 params?: ChatGetDirectChatIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatGetDirectChatId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getChatGetDirectChatIdQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getChatGetDirectChatIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof chatGetDirectChatId>>, TError = ErrorType<unknown>>(params?: ChatGetDirectChatIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetDirectChatId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getChatGetDirectChatIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof chatGetDirectChatId>>> = ({ signal }) => chatGetDirectChatId(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetDirectChatId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ChatGetDirectChatIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof chatGetDirectChatId>>>
export type ChatGetDirectChatIdSuspenseQueryError = ErrorType<unknown>


export function useChatGetDirectChatIdSuspense<TData = Awaited<ReturnType<typeof chatGetDirectChatId>>, TError = ErrorType<unknown>>(
 params: undefined |  ChatGetDirectChatIdParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetDirectChatId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChatGetDirectChatIdSuspense<TData = Awaited<ReturnType<typeof chatGetDirectChatId>>, TError = ErrorType<unknown>>(
 params?: ChatGetDirectChatIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetDirectChatId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChatGetDirectChatIdSuspense<TData = Awaited<ReturnType<typeof chatGetDirectChatId>>, TError = ErrorType<unknown>>(
 params?: ChatGetDirectChatIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetDirectChatId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useChatGetDirectChatIdSuspense<TData = Awaited<ReturnType<typeof chatGetDirectChatId>>, TError = ErrorType<unknown>>(
 params?: ChatGetDirectChatIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetDirectChatId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getChatGetDirectChatIdSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getChatSoftDeleteChatMessageUrl = (params?: ChatSoftDeleteChatMessageParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Chat/SoftDeleteChatMessage?${stringifiedParams}` : `/api/Chat/SoftDeleteChatMessage`
}

export const chatSoftDeleteChatMessage = async (params?: ChatSoftDeleteChatMessageParams, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getChatSoftDeleteChatMessageUrl(params),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getChatSoftDeleteChatMessageMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chatSoftDeleteChatMessage>>, TError,{params?: ChatSoftDeleteChatMessageParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof chatSoftDeleteChatMessage>>, TError,{params?: ChatSoftDeleteChatMessageParams}, TContext> => {

const mutationKey = ['chatSoftDeleteChatMessage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof chatSoftDeleteChatMessage>>, {params?: ChatSoftDeleteChatMessageParams}> = (props) => {
          const {params} = props ?? {};

          return  chatSoftDeleteChatMessage(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ChatSoftDeleteChatMessageMutationResult = NonNullable<Awaited<ReturnType<typeof chatSoftDeleteChatMessage>>>
    
    export type ChatSoftDeleteChatMessageMutationError = ErrorType<unknown>

    export const useChatSoftDeleteChatMessage = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chatSoftDeleteChatMessage>>, TError,{params?: ChatSoftDeleteChatMessageParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof chatSoftDeleteChatMessage>>,
        TError,
        {params?: ChatSoftDeleteChatMessageParams},
        TContext
      > => {

      const mutationOptions = getChatSoftDeleteChatMessageMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getChatGetFeedPostsUrl = (params?: ChatGetFeedPostsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Chat/GetFeedPosts?${stringifiedParams}` : `/api/Chat/GetFeedPosts`
}

export const chatGetFeedPosts = async (params?: ChatGetFeedPostsParams, options?: RequestInit): Promise<ChatPostDtoPagination> => {
  
  return customInstance<ChatPostDtoPagination>(getChatGetFeedPostsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getChatGetFeedPostsQueryKey = (params?: ChatGetFeedPostsParams,) => {
    return [
    `/api/Chat/GetFeedPosts`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getChatGetFeedPostsQueryOptions = <TData = Awaited<ReturnType<typeof chatGetFeedPosts>>, TError = ErrorType<unknown>>(params?: ChatGetFeedPostsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatGetFeedPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getChatGetFeedPostsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof chatGetFeedPosts>>> = ({ signal }) => chatGetFeedPosts(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof chatGetFeedPosts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ChatGetFeedPostsQueryResult = NonNullable<Awaited<ReturnType<typeof chatGetFeedPosts>>>
export type ChatGetFeedPostsQueryError = ErrorType<unknown>


export function useChatGetFeedPosts<TData = Awaited<ReturnType<typeof chatGetFeedPosts>>, TError = ErrorType<unknown>>(
 params: undefined |  ChatGetFeedPostsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatGetFeedPosts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof chatGetFeedPosts>>,
          TError,
          Awaited<ReturnType<typeof chatGetFeedPosts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChatGetFeedPosts<TData = Awaited<ReturnType<typeof chatGetFeedPosts>>, TError = ErrorType<unknown>>(
 params?: ChatGetFeedPostsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatGetFeedPosts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof chatGetFeedPosts>>,
          TError,
          Awaited<ReturnType<typeof chatGetFeedPosts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChatGetFeedPosts<TData = Awaited<ReturnType<typeof chatGetFeedPosts>>, TError = ErrorType<unknown>>(
 params?: ChatGetFeedPostsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatGetFeedPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useChatGetFeedPosts<TData = Awaited<ReturnType<typeof chatGetFeedPosts>>, TError = ErrorType<unknown>>(
 params?: ChatGetFeedPostsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatGetFeedPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getChatGetFeedPostsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getChatGetFeedPostsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof chatGetFeedPosts>>, TError = ErrorType<unknown>>(params?: ChatGetFeedPostsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetFeedPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getChatGetFeedPostsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof chatGetFeedPosts>>> = ({ signal }) => chatGetFeedPosts(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetFeedPosts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ChatGetFeedPostsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof chatGetFeedPosts>>>
export type ChatGetFeedPostsSuspenseQueryError = ErrorType<unknown>


export function useChatGetFeedPostsSuspense<TData = Awaited<ReturnType<typeof chatGetFeedPosts>>, TError = ErrorType<unknown>>(
 params: undefined |  ChatGetFeedPostsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetFeedPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChatGetFeedPostsSuspense<TData = Awaited<ReturnType<typeof chatGetFeedPosts>>, TError = ErrorType<unknown>>(
 params?: ChatGetFeedPostsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetFeedPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChatGetFeedPostsSuspense<TData = Awaited<ReturnType<typeof chatGetFeedPosts>>, TError = ErrorType<unknown>>(
 params?: ChatGetFeedPostsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetFeedPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useChatGetFeedPostsSuspense<TData = Awaited<ReturnType<typeof chatGetFeedPosts>>, TError = ErrorType<unknown>>(
 params?: ChatGetFeedPostsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetFeedPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getChatGetFeedPostsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getChatGetFeedPostsForUserUrl = (params: ChatGetFeedPostsForUserParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Chat/GetFeedPostsForUser?${stringifiedParams}` : `/api/Chat/GetFeedPostsForUser`
}

export const chatGetFeedPostsForUser = async (params: ChatGetFeedPostsForUserParams, options?: RequestInit): Promise<ChatPostDtoPagination> => {
  
  return customInstance<ChatPostDtoPagination>(getChatGetFeedPostsForUserUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getChatGetFeedPostsForUserQueryKey = (params?: ChatGetFeedPostsForUserParams,) => {
    return [
    `/api/Chat/GetFeedPostsForUser`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getChatGetFeedPostsForUserQueryOptions = <TData = Awaited<ReturnType<typeof chatGetFeedPostsForUser>>, TError = ErrorType<unknown>>(params: ChatGetFeedPostsForUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatGetFeedPostsForUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getChatGetFeedPostsForUserQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof chatGetFeedPostsForUser>>> = ({ signal }) => chatGetFeedPostsForUser(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof chatGetFeedPostsForUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ChatGetFeedPostsForUserQueryResult = NonNullable<Awaited<ReturnType<typeof chatGetFeedPostsForUser>>>
export type ChatGetFeedPostsForUserQueryError = ErrorType<unknown>


export function useChatGetFeedPostsForUser<TData = Awaited<ReturnType<typeof chatGetFeedPostsForUser>>, TError = ErrorType<unknown>>(
 params: ChatGetFeedPostsForUserParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatGetFeedPostsForUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof chatGetFeedPostsForUser>>,
          TError,
          Awaited<ReturnType<typeof chatGetFeedPostsForUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChatGetFeedPostsForUser<TData = Awaited<ReturnType<typeof chatGetFeedPostsForUser>>, TError = ErrorType<unknown>>(
 params: ChatGetFeedPostsForUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatGetFeedPostsForUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof chatGetFeedPostsForUser>>,
          TError,
          Awaited<ReturnType<typeof chatGetFeedPostsForUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChatGetFeedPostsForUser<TData = Awaited<ReturnType<typeof chatGetFeedPostsForUser>>, TError = ErrorType<unknown>>(
 params: ChatGetFeedPostsForUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatGetFeedPostsForUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useChatGetFeedPostsForUser<TData = Awaited<ReturnType<typeof chatGetFeedPostsForUser>>, TError = ErrorType<unknown>>(
 params: ChatGetFeedPostsForUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatGetFeedPostsForUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getChatGetFeedPostsForUserQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getChatGetFeedPostsForUserSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof chatGetFeedPostsForUser>>, TError = ErrorType<unknown>>(params: ChatGetFeedPostsForUserParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetFeedPostsForUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getChatGetFeedPostsForUserQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof chatGetFeedPostsForUser>>> = ({ signal }) => chatGetFeedPostsForUser(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetFeedPostsForUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ChatGetFeedPostsForUserSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof chatGetFeedPostsForUser>>>
export type ChatGetFeedPostsForUserSuspenseQueryError = ErrorType<unknown>


export function useChatGetFeedPostsForUserSuspense<TData = Awaited<ReturnType<typeof chatGetFeedPostsForUser>>, TError = ErrorType<unknown>>(
 params: ChatGetFeedPostsForUserParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetFeedPostsForUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChatGetFeedPostsForUserSuspense<TData = Awaited<ReturnType<typeof chatGetFeedPostsForUser>>, TError = ErrorType<unknown>>(
 params: ChatGetFeedPostsForUserParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetFeedPostsForUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChatGetFeedPostsForUserSuspense<TData = Awaited<ReturnType<typeof chatGetFeedPostsForUser>>, TError = ErrorType<unknown>>(
 params: ChatGetFeedPostsForUserParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetFeedPostsForUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useChatGetFeedPostsForUserSuspense<TData = Awaited<ReturnType<typeof chatGetFeedPostsForUser>>, TError = ErrorType<unknown>>(
 params: ChatGetFeedPostsForUserParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetFeedPostsForUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getChatGetFeedPostsForUserSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getChatGetFeedPostUrl = (params?: ChatGetFeedPostParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Chat/GetFeedPost?${stringifiedParams}` : `/api/Chat/GetFeedPost`
}

export const chatGetFeedPost = async (params?: ChatGetFeedPostParams, options?: RequestInit): Promise<ChatPostDto> => {
  
  return customInstance<ChatPostDto>(getChatGetFeedPostUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getChatGetFeedPostQueryKey = (params?: ChatGetFeedPostParams,) => {
    return [
    `/api/Chat/GetFeedPost`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getChatGetFeedPostQueryOptions = <TData = Awaited<ReturnType<typeof chatGetFeedPost>>, TError = ErrorType<unknown>>(params?: ChatGetFeedPostParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatGetFeedPost>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getChatGetFeedPostQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof chatGetFeedPost>>> = ({ signal }) => chatGetFeedPost(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof chatGetFeedPost>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ChatGetFeedPostQueryResult = NonNullable<Awaited<ReturnType<typeof chatGetFeedPost>>>
export type ChatGetFeedPostQueryError = ErrorType<unknown>


export function useChatGetFeedPost<TData = Awaited<ReturnType<typeof chatGetFeedPost>>, TError = ErrorType<unknown>>(
 params: undefined |  ChatGetFeedPostParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatGetFeedPost>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof chatGetFeedPost>>,
          TError,
          Awaited<ReturnType<typeof chatGetFeedPost>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChatGetFeedPost<TData = Awaited<ReturnType<typeof chatGetFeedPost>>, TError = ErrorType<unknown>>(
 params?: ChatGetFeedPostParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatGetFeedPost>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof chatGetFeedPost>>,
          TError,
          Awaited<ReturnType<typeof chatGetFeedPost>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChatGetFeedPost<TData = Awaited<ReturnType<typeof chatGetFeedPost>>, TError = ErrorType<unknown>>(
 params?: ChatGetFeedPostParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatGetFeedPost>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useChatGetFeedPost<TData = Awaited<ReturnType<typeof chatGetFeedPost>>, TError = ErrorType<unknown>>(
 params?: ChatGetFeedPostParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chatGetFeedPost>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getChatGetFeedPostQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getChatGetFeedPostSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof chatGetFeedPost>>, TError = ErrorType<unknown>>(params?: ChatGetFeedPostParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetFeedPost>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getChatGetFeedPostQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof chatGetFeedPost>>> = ({ signal }) => chatGetFeedPost(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetFeedPost>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ChatGetFeedPostSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof chatGetFeedPost>>>
export type ChatGetFeedPostSuspenseQueryError = ErrorType<unknown>


export function useChatGetFeedPostSuspense<TData = Awaited<ReturnType<typeof chatGetFeedPost>>, TError = ErrorType<unknown>>(
 params: undefined |  ChatGetFeedPostParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetFeedPost>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChatGetFeedPostSuspense<TData = Awaited<ReturnType<typeof chatGetFeedPost>>, TError = ErrorType<unknown>>(
 params?: ChatGetFeedPostParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetFeedPost>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useChatGetFeedPostSuspense<TData = Awaited<ReturnType<typeof chatGetFeedPost>>, TError = ErrorType<unknown>>(
 params?: ChatGetFeedPostParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetFeedPost>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useChatGetFeedPostSuspense<TData = Awaited<ReturnType<typeof chatGetFeedPost>>, TError = ErrorType<unknown>>(
 params?: ChatGetFeedPostParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof chatGetFeedPost>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getChatGetFeedPostSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getChatDeletePostUrl = (params?: ChatDeletePostParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Chat/DeletePost?${stringifiedParams}` : `/api/Chat/DeletePost`
}

export const chatDeletePost = async (params?: ChatDeletePostParams, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getChatDeletePostUrl(params),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getChatDeletePostMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chatDeletePost>>, TError,{params?: ChatDeletePostParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof chatDeletePost>>, TError,{params?: ChatDeletePostParams}, TContext> => {

const mutationKey = ['chatDeletePost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof chatDeletePost>>, {params?: ChatDeletePostParams}> = (props) => {
          const {params} = props ?? {};

          return  chatDeletePost(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ChatDeletePostMutationResult = NonNullable<Awaited<ReturnType<typeof chatDeletePost>>>
    
    export type ChatDeletePostMutationError = ErrorType<unknown>

    export const useChatDeletePost = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chatDeletePost>>, TError,{params?: ChatDeletePostParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof chatDeletePost>>,
        TError,
        {params?: ChatDeletePostParams},
        TContext
      > => {

      const mutationOptions = getChatDeletePostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getChatToggleReactionUrl = (params?: ChatToggleReactionParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Chat/ToggleReaction?${stringifiedParams}` : `/api/Chat/ToggleReaction`
}

export const chatToggleReaction = async (params?: ChatToggleReactionParams, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getChatToggleReactionUrl(params),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getChatToggleReactionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chatToggleReaction>>, TError,{params?: ChatToggleReactionParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof chatToggleReaction>>, TError,{params?: ChatToggleReactionParams}, TContext> => {

const mutationKey = ['chatToggleReaction'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof chatToggleReaction>>, {params?: ChatToggleReactionParams}> = (props) => {
          const {params} = props ?? {};

          return  chatToggleReaction(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ChatToggleReactionMutationResult = NonNullable<Awaited<ReturnType<typeof chatToggleReaction>>>
    
    export type ChatToggleReactionMutationError = ErrorType<unknown>

    export const useChatToggleReaction = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chatToggleReaction>>, TError,{params?: ChatToggleReactionParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof chatToggleReaction>>,
        TError,
        {params?: ChatToggleReactionParams},
        TContext
      > => {

      const mutationOptions = getChatToggleReactionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getChatToggleSubscribeFeedUrl = () => {


  

  return `/api/Chat/ToggleSubscribeFeed`
}

export const chatToggleSubscribeFeed = async (toggleSubscribeFeedRequest: ToggleSubscribeFeedRequest, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getChatToggleSubscribeFeedUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      toggleSubscribeFeedRequest,)
  }
);}




export const getChatToggleSubscribeFeedMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chatToggleSubscribeFeed>>, TError,{data: BodyType<ToggleSubscribeFeedRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof chatToggleSubscribeFeed>>, TError,{data: BodyType<ToggleSubscribeFeedRequest>}, TContext> => {

const mutationKey = ['chatToggleSubscribeFeed'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof chatToggleSubscribeFeed>>, {data: BodyType<ToggleSubscribeFeedRequest>}> = (props) => {
          const {data} = props ?? {};

          return  chatToggleSubscribeFeed(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ChatToggleSubscribeFeedMutationResult = NonNullable<Awaited<ReturnType<typeof chatToggleSubscribeFeed>>>
    export type ChatToggleSubscribeFeedMutationBody = BodyType<ToggleSubscribeFeedRequest>
    export type ChatToggleSubscribeFeedMutationError = ErrorType<unknown>

    export const useChatToggleSubscribeFeed = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chatToggleSubscribeFeed>>, TError,{data: BodyType<ToggleSubscribeFeedRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof chatToggleSubscribeFeed>>,
        TError,
        {data: BodyType<ToggleSubscribeFeedRequest>},
        TContext
      > => {

      const mutationOptions = getChatToggleSubscribeFeedMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    